import {FC} from 'react'
import CheckInParking from '../components/CheckInParking'

const HeaderCheckInParqueoPanel: FC = () => {
  return (
    <>
      <div className=''>
        <CheckInParking />
      </div>
    </>
  )
}

export {HeaderCheckInParqueoPanel}
